import React, { FC } from 'react';
import { Col, Row } from 'react-bootstrap';
import header from '../assets/img/logo.png';

const Header: FC = () => {
  return (
    <>
      <Row>
        <Col>
          <header style={{ display: 'flex' }}>
            <img src={header} />
          </header>
        </Col>
      </Row>
    </>
  );
};

export default Header;
